import $ from 'jquery';
window.addEventListener('px-ready',function(){
    //$('body').removeClass('is-mobile-menu-active');
    $('.px-menu-opener').on('click',function(){
        $('body').attr('opener-lock',1)
        window.setTimeout(function(){
            if($('body').attr('opener-lock') == 1){
                $('body').toggleClass('is-mobile-menu-active');
                $(window).trigger('resize');
                $('body').attr('opener-lock',0)
            }
        },10)
    })
})